<span class="comparison-badge display-inline-block text-xs bold is-{{ state }}">{{ label }}</span>
